import { t } from 'typegate';
// NOTE: Please update the README.md in shared/questionnaire-engine if this is modified.
export const PlatformTypes = {
    consumer: 'consumer',
    producer: 'producer',
};
export const platformType = t.union(t.literal('consumer'), t.literal('producer'));
